import React, { useState, useEffect } from "react";
import { 
  FileText, 
  Filter, 
  RefreshCw, 
  Download, 
  AlertTriangle, 
  CheckCircle,
  Calendar,
  ChevronDown,
  Search,
  X,
  Users,
  TrendingUp,
  Store,
  ChevronLeft,
  ChevronRight,
  Settings,
  Loader,
  Euro,
  Package,
  ShoppingCart
} from "lucide-react";

const API_URL = process.env.REACT_APP_API_URL;

// Componente del Panel Lateral
const SidePanel = ({ 
  isOpen, 
  setIsOpen,
  // Props para filtros principales
  mesActual,
  setMesActual,
  anioActual,
  setAnioActual,
  handleFilter,
  handleCrearExcel,
  loadingExcel,
  pedidos,
  meses,
  loading,
  totales,
  formatCurrency,
  // Props para productos con ahorro
  mesInicio,
  setMesInicio,
  anioInicio,
  setAnioInicio,
  mesFin,
  setMesFin,
  anioFin,
  setAnioFin,
  proveedor,
  setProveedor,
  clientesSeleccionados,
  setClientesSeleccionados,
  clienteSeleccionado,
  setClienteSeleccionado,
  clientes,
  handleAgregarCliente,
  handleEliminarCliente,
  handleGenerarExcelProductos,
  loadingExcelProductos
}) => {
  return (
    <>
      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed left-4 top-1/2 transform -translate-y-1/2 z-50 bg-white border border-gray-300 rounded-r-lg p-3 shadow-lg hover:bg-gray-50 transition-all duration-300"
        style={{
          left: isOpen ? '384px' : '4px'
        }}
      >
        {isOpen ? <ChevronLeft size={20} className="text-gray-600" /> : <ChevronRight size={20} className="text-gray-600" />}
      </button>

      {/* Side Panel */}
      <div 
        className="fixed left-0 top-16 bottom-0 bg-white border-r border-gray-200 shadow-lg transition-transform duration-300 z-40 overflow-hidden"
        style={{
          width: '380px',
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)'
        }}
      >
        <div className="h-full flex flex-col">
          
          {/* Panel Header */}
          <div className="p-4 border-b border-gray-200 bg-gradient-to-r from-teal-50 to-green-50">
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-lg font-semibold text-gray-800 flex items-center">
                <Settings size={20} className="mr-2 text-teal-600" />
                Panel de Control
              </h2>
            </div>
            <p className="text-sm text-gray-600">
              Configura filtros y genera reportes de pedidos cerrados
            </p>
          </div>

          <div className="flex-1 overflow-y-auto">
            
            {/* FORMULARIO 1: Filtros de Pedidos Cerrados */}
            <div className="border-b-4 border-teal-300 bg-gradient-to-r from-teal-50 to-emerald-50">
              <div className="p-4">
                
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-2">Mes de Cierre</label>
                      <div className="relative">
                        <select 
                          className="block w-full pl-3 pr-8 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors appearance-none bg-white"
                          value={mesActual}
                          onChange={(e) => setMesActual(e.target.value)}
                        >
                          {meses.map((mes, index) => (
                            <option key={index + 1} value={index + 1}>
                              {mes}
                            </option>
                          ))}
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                          <ChevronDown size={16} className="text-gray-500" />
                        </div>
                      </div>
                    </div>
                    
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-2">Año de Cierre</label>
                      <div className="relative">
                        <select 
                          className="block w-full pl-3 pr-8 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors appearance-none bg-white"
                          value={anioActual}
                          onChange={(e) => setAnioActual(e.target.value)}
                        >
                          {Array.from({ length: 6 }, (_, i) => {
                            const year = new Date().getFullYear() - 5 + i;
                            return (
                              <option key={year} value={year}>
                                {year}
                              </option>
                            );
                          })}
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                          <ChevronDown size={16} className="text-gray-500" />
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 gap-2">
                    <button 
                      onClick={handleFilter} 
                      className="flex items-center justify-center px-4 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 transition-all duration-200 shadow-sm font-medium text-sm"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Loader size={16} className="mr-2 animate-spin" />
                          Buscando...
                        </>
                      ) : (
                        <>
                          <Search size={16} className="mr-2" />
                          Buscar Pedidos
                        </>
                      )}
                    </button>
                    
                    <button 
                      onClick={handleCrearExcel}
                      className="flex items-center justify-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-all duration-200 shadow-sm font-medium text-sm border-2 border-green-700"
                      disabled={loadingExcel || pedidos.length === 0}
                    >
                      {loadingExcel ? (
                        <>
                          <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white mr-2"></div>
                          <span>Generando Excel 1...</span>
                        </>
                      ) : (
                        <>
                          <Download size={16} className="mr-2" />
                          <span> EXCEL PEDIDOS CERRADOS</span>
                        </>
                      )}
                    </button>

                  </div>
                </div>
              </div>
            </div>

            {/* SEPARADOR VISUAL */}
            <div className="h-4 bg-gradient-to-r from-gray-100 to-gray-200"></div>

            {/* FORMULARIO 2: Productos con Ahorro */}
            <div className="bg-gradient-to-r from-orange-50 to-amber-50">
              <div className="p-4">
                <div className="bg-orange-100 rounded-lg p-3 mb-4 border-l-4 border-orange-500">
                  <h3 className="text-sm font-bold text-orange-800 mb-1 flex items-center">
                    <TrendingUp size={18} className="mr-2" />
                    Productos con Ahorro
                  </h3>
                  <p className="text-xs text-orange-700">Configure período personalizado, filtros de proveedor y clientes específicos</p>
                </div>
                
                <div className="space-y-4">
                  
                  {/* Rango de fechas */}
                  <div className="bg-white rounded-lg p-3 border border-orange-200 shadow-sm">
                    <h4 className="font-medium text-orange-800 mb-3 text-xs flex items-center">
                      <Calendar size={14} className="mr-1" />
                      Período de Análisis
                    </h4>
                    
                    <div className="space-y-3">
                      <div className="grid grid-cols-2 gap-2">
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Mes Inicio</label>
                          <select 
                            className="block w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-xs"
                            value={mesInicio}
                            onChange={(e) => setMesInicio(parseInt(e.target.value))}
                            required
                          >
                            {meses.map((mes, index) => (
                              <option key={index + 1} value={index + 1}>
                                {mes}
                              </option>
                            ))}
                          </select>
                        </div>
                        
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Año Inicio</label>
                          <select 
                            className="block w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-xs"
                            value={anioInicio}
                            onChange={(e) => setAnioInicio(parseInt(e.target.value))}
                            required
                          >
                            {Array.from({ length: 6 }, (_, i) => {
                              const year = new Date().getFullYear() - 5 + i;
                              return (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      
                      <div className="text-center text-xs text-gray-500 font-medium">
                        ↓ HASTA ↓
                      </div>
                      
                      <div className="grid grid-cols-2 gap-2">
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Mes Fin</label>
                          <select 
                            className="block w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-xs"
                            value={mesFin}
                            onChange={(e) => setMesFin(parseInt(e.target.value))}
                            required
                          >
                            {meses.map((mes, index) => (
                              <option key={index + 1} value={index + 1}>
                                {mes}
                              </option>
                            ))}
                          </select>
                        </div>
                        
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Año Fin</label>
                          <select 
                            className="block w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-xs"
                            value={anioFin}
                            onChange={(e) => setAnioFin(parseInt(e.target.value))}
                            required
                          >
                            {Array.from({ length: 6 }, (_, i) => {
                              const year = new Date().getFullYear() - 5 + i;
                              return (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Filtros adicionales */}
                  <div className="bg-white rounded-lg p-3 border border-orange-200 shadow-sm">
                    <h4 className="font-medium text-orange-800 mb-3 text-xs flex items-center">
                      <Filter size={14} className="mr-1" />
                      Filtros de Análisis
                    </h4>
                    
                    {/* Selector de Proveedor */}
                    <div className="mb-3">
                      <label className="block text-xs font-medium text-gray-700 mb-1 flex items-center">
                        <Store size={12} className="mr-1 text-gray-500" />
                        Proveedor
                      </label>
                      <select 
                        className="block w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-xs"
                        value={proveedor}
                        onChange={(e) => setProveedor(e.target.value)}
                      >
                        <option value="todos">Todos los proveedores</option>
                        <option value="hispafarma">HISPAFARMA</option>
                        <option value="kalamazoo">KALAMAZOO</option>
                      </select>
                    </div>
                    
                    {/* Selector de Clientes */}
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1 flex items-center">
                        <Users size={12} className="mr-1 text-gray-500" />
                        Clientes Específicos (opcional)
                      </label>
                      <div className="flex gap-2 mb-2">
                        <select 
                          className="w-40 px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-xs"
                          value={clienteSeleccionado}
                          onChange={(e) => setClienteSeleccionado(e.target.value)}
                        >
                          <option value="">-- Seleccione --</option>
                          {clientes.map(cliente => (
                            <option key={cliente.id} value={cliente.id}>
                              {cliente.razon_social.length > 25 ? 
                                cliente.razon_social.substring(0, 25) + '...' : 
                                cliente.razon_social}
                            </option>
                          ))}
                        </select>
                        <button 
                          type="button" 
                          className="px-3 py-2 bg-teal-500 text-white rounded-md hover:bg-teal-600 transition-colors flex items-center text-xs font-medium whitespace-nowrap shadow-sm"
                          onClick={handleAgregarCliente}
                        >
                          <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                          Añadir
                        </button>
                      </div>
                      
                      {/* Clientes seleccionados */}
                      <div className="min-h-12 border-2 border-dashed border-orange-300 rounded-md p-2 bg-orange-25">
                        {clientesSeleccionados.length === 0 ? (
                          <p className="text-gray-500 text-xs text-center py-1 flex items-center justify-center">
                            <Users size={10} className="mr-1" />
                            Todos los clientes (sin filtro específico)
                          </p>
                        ) : (
                          <div>
                            <p className="text-xs text-orange-700 font-medium mb-1">
                              {clientesSeleccionados.length} cliente(s) seleccionado(s):
                            </p>
                            <div className="flex flex-wrap gap-1">
                              {clientesSeleccionados.map(cliente => (
                                <div key={cliente.id} className="bg-orange-100 border border-orange-400 rounded-md px-2 py-1 flex items-center text-xs">
                                  <span className="max-w-20 truncate" title={cliente.razon_social}>
                                    {cliente.razon_social}
                                  </span>
                                  <button 
                                    type="button" 
                                    className="ml-1 text-red-500 hover:text-red-700"
                                    onClick={() => handleEliminarCliente(cliente.id)}
                                  >
                                    <X size={10} />
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  <button 
                    onClick={handleGenerarExcelProductos}
                    className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-all duration-200 shadow-lg font-bold flex items-center justify-center text-sm border-2 border-green-800"
                    disabled={loadingExcelProductos}
                  >
                    {loadingExcelProductos ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white mr-2"></div>
                        <span>Generando Excel 2...</span>
                      </>
                    ) : (
                      <>
                        <Download size={16} className="mr-2" />
                        <span> EXCEL PRODUCTOS AHORRO</span>
                      </>
                    )}
                  </button>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const PedidosCerrados = () => {
  const token = localStorage.getItem("token");

  // Estados para datos
  const [pedidos, setPedidos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [totales, setTotales] = useState({
    totalAhorro: 0,
    totalPedidos: 0,
    totalConIva: 0
  });
  
  // Estados para filtros principales (por fecha de cierre)
  const [mesActual, setMesActual] = useState(new Date().getMonth() + 1);
  const [anioActual, setAnioActual] = useState(new Date().getFullYear());
  
  // Estados para control de carga
  const [loading, setLoading] = useState(true);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingExcelProductos, setLoadingExcelProductos] = useState(false);
  const [error, setError] = useState(null);
  const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });

  // Estados para el formulario de productos con ahorro
  const [mesInicio, setMesInicio] = useState(new Date().getMonth() + 1);
  const [anioInicio, setAnioInicio] = useState(new Date().getFullYear());
  const [mesFin, setMesFin] = useState(new Date().getMonth() + 1);
  const [anioFin, setAnioFin] = useState(new Date().getFullYear());
  const [proveedor, setProveedor] = useState("todos");
  const [clientesSeleccionados, setClientesSeleccionados] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState("");

  // Estado para el panel lateral
  const [sidePanelOpen, setSidePanelOpen] = useState(true);

  // Nombres de meses
  const meses = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];

  // Función para buscar pedidos cerrados (ahora usa fecha_cierre)
  const fetchPedidosCerrados = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(`${API_URL}/api/pedidos-cerrados?mes=${mesActual}&anio=${anioActual}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Error al obtener los pedidos cerrados");
      }

      const data = await response.json();
      setPedidos(data.pedidos);
      setTotales(data.totales);
      setClientes(data.clientes);
    } catch (error) {
      console.error("Error:", error);
      setError("No se pudieron cargar los pedidos cerrados. " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Cargar datos de pedidos cerrados
  useEffect(() => {
    fetchPedidosCerrados();
  }, [mesActual, anioActual]);

  // Filtrar por mes y año
  const handleFilter = (e) => {
    e.preventDefault();
    fetchPedidosCerrados();
  };

  // Generar Excel de pedidos cerrados (por fecha de cierre)
  const handleCrearExcel = async () => {
    try {
      setLoadingExcel(true);
      setMensaje({
        texto: "Generando Excel, por favor espere...",
        tipo: "success",
      });

      const response = await fetch(`${API_URL}/api/pedidos-cerrados/excel`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mes: mesActual,
          anio: anioActual,
        }),
      });

      if (!response.ok) {
        throw new Error("Error al generar el Excel");
      }

      // Obtener blob del Excel
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Pedidos_Cerrados_${mesActual}_${anioActual}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();

      setMensaje({
        texto: "Excel descargado correctamente",
        tipo: "success",
      });
      
      // Auto-cerrar el mensaje después de 5 segundos
      setTimeout(() => {
        setMensaje({ texto: "", tipo: "" });
      }, 5000);
    } catch (error) {
      console.error("Error:", error);
      setMensaje({
        texto: "Error al generar el Excel: " + error.message,
        tipo: "error",
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  // Generar Excel de productos con ahorro
  const handleGenerarExcelProductos = async () => {
    // Validar fechas
    const fechaInicio = new Date(anioInicio, mesInicio - 1, 1);
    const fechaFin = new Date(anioFin, mesFin - 1, 1);
    
    if (fechaFin < fechaInicio) {
      setMensaje({
        texto: "La fecha de fin debe ser posterior a la fecha de inicio",
        tipo: "error",
      });
      setTimeout(() => setMensaje({ texto: "", tipo: "" }), 3000);
      return;
    }
    
    try {
      setLoadingExcelProductos(true);
      setMensaje({
        texto: "Generando Excel de productos con ahorro, por favor espere...",
        tipo: "success",
      });
      
      const clientesIds = clientesSeleccionados.map(cliente => cliente.id);
      
      // DEBUG: Verificar datos que se envían
      console.log("Datos enviados al endpoint:", {
        mes_inicio: mesInicio,
        anio_inicio: anioInicio,
        mes_fin: mesFin,
        anio_fin: anioFin,
        proveedor: proveedor,
        clientes_ids: clientesIds
      });
      
      const response = await fetch(`${API_URL}/api/productos-ahorro/excel`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mes_inicio: mesInicio,
          anio_inicio: anioInicio,
          mes_fin: mesFin,
          anio_fin: anioFin,
          proveedor: proveedor,
          clientes_ids: clientesIds
        }),
      });
      
      if (!response.ok) {
        throw new Error(`Error al generar el Excel de productos con ahorro (${response.status})`);
      }
      
      // Obtener blob del Excel
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Productos_Ahorro_${mesInicio}-${anioInicio}_a_${mesFin}-${anioFin}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      
      setMensaje({
        texto: "Excel de productos con ahorro descargado correctamente",
        tipo: "success",
      });
      
      // Auto-cerrar el mensaje después de 5 segundos
      setTimeout(() => {
        setMensaje({ texto: "", tipo: "" });
      }, 5000);
    } catch (error) {
      console.error("Error:", error);
      setMensaje({
        texto: "Error al generar el Excel: " + error.message,
        tipo: "error",
      });
      setTimeout(() => setMensaje({ texto: "", tipo: "" }), 5000);
    } finally {
      setLoadingExcelProductos(false);
    }
  };

  // Agregar cliente seleccionado
  const handleAgregarCliente = () => {
    if (!clienteSeleccionado || clienteSeleccionado === "") {
      setMensaje({
        texto: "Por favor, seleccione un cliente para añadir",
        tipo: "error",
      });
      setTimeout(() => setMensaje({ texto: "", tipo: "" }), 3000);
      return;
    }
    
    // Verificar si el cliente ya está seleccionado
    const yaSeleccionado = clientesSeleccionados.some(
      cliente => cliente.id === parseInt(clienteSeleccionado)
    );
    
    if (yaSeleccionado) {
      setMensaje({
        texto: "Este cliente ya ha sido agregado",
        tipo: "error",
      });
      setTimeout(() => setMensaje({ texto: "", tipo: "" }), 3000);
      return;
    }
    
    // Buscar el cliente en la lista
    const cliente = clientes.find(c => c.id.toString() === clienteSeleccionado);
    
    if (cliente) {
      setClientesSeleccionados(prev => [...prev, cliente]);
      setClienteSeleccionado("");
      setMensaje({
        texto: `Cliente "${cliente.razon_social}" agregado correctamente`,
        tipo: "success",
      });
      setTimeout(() => setMensaje({ texto: "", tipo: "" }), 2000);
    } else {
      setMensaje({
        texto: "Cliente no encontrado",
        tipo: "error",
      });
      setTimeout(() => setMensaje({ texto: "", tipo: "" }), 3000);
    }
  };

  // Eliminar cliente de la selección
  const handleEliminarCliente = (id) => {
    setClientesSeleccionados(prev => 
      prev.filter(cliente => cliente.id !== id)
    );
    setMensaje({
      texto: "Cliente eliminado de la selección",
      tipo: "success",
    });
    setTimeout(() => setMensaje({ texto: "", tipo: "" }), 2000);
  };

  // Formatear fecha
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES");
  };

  // Formatear moneda
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  // Componente del estado de carga
  if (loading && !pedidos.length) {
    return (
      <div className="fixed inset-0 top-16 bg-gradient-to-br from-gray-50 to-gray-100 flex justify-center items-center">
        <div className="text-center">
          <div className="relative mb-8">
            <div className="w-20 h-20 border-4 rounded-full animate-spin border-t-teal-600 mx-auto" style={{borderColor: '#14b8a640', borderTopColor: '#14b8a6'}}></div>
            <FileText className="w-8 h-8 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-teal-500" />
          </div>
          <h3 className="text-xl font-bold mb-2 text-teal-600">Cargando pedidos cerrados</h3>
          <p className="text-gray-600">Obteniendo datos de facturación...</p>
        </div>
      </div>
    );
  }

  // Componente de error
  if (error && !pedidos.length) {
    return (
      <div className="fixed inset-0 top-16 bg-gradient-to-br from-gray-50 to-gray-100 flex justify-center items-center">
        <div className="bg-red-100 text-red-800 p-6 rounded-xl shadow-lg max-w-lg w-full border border-red-200 mx-4">
          <div className="flex items-start">
            <AlertTriangle size={28} className="text-red-500 mr-4 flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-bold text-lg text-red-700 mb-2">Error de carga</h3>
              <p className="text-red-700">{error}</p>
              <button 
                onClick={() => fetchPedidosCerrados()}
                className="mt-4 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-md transition-all duration-200 inline-flex items-center"
              >
                <RefreshCw size={16} className="mr-2" />
                Reintentar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 top-16 bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden">
      
      {/* Panel Lateral */}
      <SidePanel
        isOpen={sidePanelOpen}
        setIsOpen={setSidePanelOpen}
        // Props para filtros principales
        mesActual={mesActual}
        setMesActual={setMesActual}
        anioActual={anioActual}
        setAnioActual={setAnioActual}
        handleFilter={handleFilter}
        handleCrearExcel={handleCrearExcel}
        loadingExcel={loadingExcel}
        pedidos={pedidos}
        meses={meses}
        loading={loading}
        totales={totales}
        formatCurrency={formatCurrency}
        // Props para productos con ahorro
        mesInicio={mesInicio}
        setMesInicio={setMesInicio}
        anioInicio={anioInicio}
        setAnioInicio={setAnioInicio}
        mesFin={mesFin}
        setMesFin={setMesFin}
        anioFin={anioFin}
        setAnioFin={setAnioFin}
        proveedor={proveedor}
        setProveedor={setProveedor}
        clientesSeleccionados={clientesSeleccionados}
        setClientesSeleccionados={setClientesSeleccionados}
        clienteSeleccionado={clienteSeleccionado}
        setClienteSeleccionado={setClienteSeleccionado}
        clientes={clientes}
        handleAgregarCliente={handleAgregarCliente}
        handleEliminarCliente={handleEliminarCliente}
        handleGenerarExcelProductos={handleGenerarExcelProductos}
        loadingExcelProductos={loadingExcelProductos}
      />

      {/* Área Principal */}
      <div className="h-full flex flex-col" style={{ 
        marginLeft: sidePanelOpen ? '380px' : '0px',
        transition: 'margin-left 0.3s ease-in-out'
      }}>
        
        {/* Header */}
        <div className="flex-shrink-0 bg-white shadow-sm border-b border-gray-200 p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="p-2 rounded-lg mr-3" style={{ backgroundColor: 'rgba(20, 184, 166, 0.1)' }}>
                <FileText size={20} style={{ color: '#14b8a6' }} />
              </div>
              <div>
                <h1 className="text-lg font-bold text-gray-800">Pedidos Cerrados</h1>
                <p className="text-sm text-gray-600">Gestión y análisis de pedidos facturados</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              <div className="text-right">
                <div className="text-sm font-medium text-gray-900">
                  {meses[mesActual - 1]} {anioActual}
                </div>
                <div className="text-xs text-gray-500">
                  {pedidos.length} pedidos encontrados
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contenido Principal */}
        <div className="flex-1 overflow-auto">
          <div className="h-full" style={{ 
            paddingLeft: '53px', 
            paddingRight: sidePanelOpen ? '25px' : '16px', // Más espacio cuando está abierto para no chocar con la flecha
            paddingTop: '24px', 
            paddingBottom: '24px',
            transition: 'padding-right 0.3s ease-in-out'
          }}>

            {/* Mensajes de alerta */}
            {mensaje.texto && (
              <div className={`alert mb-6 p-4 rounded-xl shadow-md transition-all duration-200 transform ${mensaje.tipo === "success" ? "bg-green-50 text-green-800 border border-green-200" : "bg-red-50 text-red-800 border border-red-200"}`}>
                <div className="flex items-start">
                  {mensaje.tipo === "success" ? (
                    <CheckCircle size={24} className="text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  ) : (
                    <AlertTriangle size={24} className="text-red-500 mr-3 flex-shrink-0 mt-0.5" />
                  )}
                  <div className="flex-1">
                    <p className="font-medium">{mensaje.texto}</p>
                  </div>
                  <button 
                    className="text-gray-500 hover:text-gray-700 transition-colors ml-2" 
                    onClick={() => setMensaje({ texto: "", tipo: "" })}
                  >
                    <X size={20} />
                  </button>
                </div>
              </div>
            )}

            {/* Tarjetas de resumen */}
            {pedidos.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 transition-all hover:shadow-xl transform hover:-translate-y-1">
                  <div className="flex items-center">
                    <div className="bg-teal-500 bg-opacity-20 p-3 rounded-full mr-4 flex items-center justify-center">
                      <Euro size={24} className="text-teal-500" />
                    </div>
                    <div>
                      <p className="text-gray-500 font-medium">Total Pedidos (sin IVA)</p>
                      <h3 className="text-2xl font-bold text-gray-800">{formatCurrency(totales.totalPedidos)}</h3>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 transition-all hover:shadow-xl transform hover:-translate-y-1">
                  <div className="flex items-center">
                    <div className="bg-blue-500 bg-opacity-20 p-3 rounded-full mr-4 flex items-center justify-center">
                      <ShoppingCart size={24} className="text-blue-500" />
                    </div>
                    <div>
                      <p className="text-gray-500 font-medium">Total con IVA</p>
                      <h3 className="text-2xl font-bold text-gray-800">{formatCurrency(totales.totalConIva)}</h3>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 transition-all hover:shadow-xl transform hover:-translate-y-1">
                  <div className="flex items-center">
                    <div className="bg-green-500 bg-opacity-20 p-3 rounded-full mr-4 flex items-center justify-center">
                      <TrendingUp size={24} className="text-green-500" />
                    </div>
                    <div>
                      <p className="text-gray-500 font-medium">Ahorro Total</p>
                      <h3 className="text-2xl font-bold text-green-600">{formatCurrency(totales.totalAhorro)}</h3>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Tabla de pedidos */}
            {pedidos.length > 0 ? (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 h-full flex flex-col">
                <div className="flex-1 overflow-auto">
                  <table className="w-full table-auto divide-y divide-gray-200">
                    <thead className="sticky top-0">
                      <tr>
                        <th className="px-6 py-4 bg-teal-500 text-white text-left text-sm font-semibold">Nº Pedido</th>
                        <th className="px-6 py-4 bg-teal-500 text-white text-left text-sm font-semibold">Fecha Pedido</th>
                        <th className="px-6 py-4 bg-teal-500 text-white text-left text-sm font-semibold">Fecha Cierre</th>
                        <th className="px-6 py-4 bg-teal-500 text-white text-left text-sm font-semibold">Cliente</th>
                        <th className="px-6 py-4 bg-teal-500 text-white text-left text-sm font-semibold">Proveedor</th>
                        <th className="px-6 py-4 bg-teal-500 text-white text-left text-sm font-semibold">Total sin IVA</th>
                        <th className="px-6 py-4 bg-teal-500 text-white text-left text-sm font-semibold">Total con IVA</th>
                        <th className="px-6 py-4 bg-teal-500 text-white text-left text-sm font-semibold">Ahorro</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {pedidos.map((pedido, index) => (
                        <tr 
                          key={pedido.id} 
                          className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
                        >
                          <td className="px-6 py-4 text-sm font-medium text-gray-900">{pedido.npedido}</td>
                          <td className="px-6 py-4 text-sm text-gray-700">{formatDate(pedido.fecha)}</td>
                          <td className="px-6 py-4 text-sm text-gray-700">{formatDate(pedido.fecha_cierre)}</td>
                          <td className="px-6 py-4 text-sm text-gray-700">{pedido.razon_social}</td>
                          <td className="px-6 py-4 text-sm text-gray-700">{pedido.proveedor_nombre}</td>
                          <td className="px-6 py-4 text-sm text-gray-700">{formatCurrency(pedido.itotal)}</td>
                          <td className="px-6 py-4 text-sm text-gray-700">{formatCurrency(pedido.itotaliva)}</td>
                          <td className="px-6 py-4 text-sm font-medium text-green-600">{formatCurrency(pedido.ahorro_total)}</td>
                        </tr>
                      ))}
                      {/* Fila de totales */}
                      <tr className="bg-teal-500 text-white font-bold">
                        <td colSpan={5} className="px-6 py-4 text-right border-t-2 border-gray-300">TOTALES</td>
                        <td className="px-6 py-4 border-t-2 border-gray-300">{formatCurrency(totales.totalPedidos)}</td>
                        <td className="px-6 py-4 border-t-2 border-gray-300">{formatCurrency(totales.totalConIva)}</td>
                        <td className="px-6 py-4 border-t-2 border-gray-300">{formatCurrency(totales.totalAhorro)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="bg-white p-10 rounded-xl text-center border border-yellow-200 shadow-md">
                <div className="flex flex-col items-center justify-center">
                  <div className="bg-yellow-100 p-4 rounded-full mb-4">
                    <AlertTriangle size={40} className="text-yellow-500" />
                  </div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">No hay pedidos cerrados</h3>
                  <p className="text-gray-600 max-w-lg mx-auto mb-6">
                    No se encontraron pedidos cerrados para el período seleccionado. Prueba con otro mes o año, o verifica que existan pedidos cerrados.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PedidosCerrados;